import React, { Component } from 'react'
import { addURL } from 'redux/actions/url'
import Form from 'devextreme-react/form'
import { Button } from 'devextreme-react'
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid'
import { showLoading } from 'redux/actions/loading'
import httpRequest from 'plugin/httprequest'
import { formatDate } from 'plugin/helper'
import ProfilePeserta from './profilePeserta'
import DetailData from './detailData'
import { alert } from 'devextreme/ui/dialog'

class DashboardClient extends Component {
  constructor(props) {
    super(props)

    this.state = {
      formData: {},
    }

    this.formRef = React.createRef()
    this.datagridPesertaRef = React.createRef()
    this.profilePesertaRef = React.createRef()
    this.detailDataRef = React.createRef()

    this.dataResult = []

    this.formItems = [
      {
        dataField: 'cardNo',
        label: {
          text: 'Nomor Kartu',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor Kartu',
        },
      },
      {
        dataField: 'fullName',
        label: {
          text: 'Nama Lengkap',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nama Lengkap',
        },
      },
      {
        dataField: 'nik',
        label: {
          text: 'NIK',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'NIK',
        },
      },
      {
        dataField: 'ktp',
        label: {
          text: 'Nomor KTP',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor KTP',
        },
      },
      {
        dataField: 'noHp',
        label: {
          text: 'Nomor HP',
        },
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          placeholder: 'Nomor HP',
        },
      },
      {
        dataField: 'tanggalLahir',
        label: {
          text: 'Tanggal Lahir',
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: 'bd-input-popup-dapen-default' },
          displayFormat: 'dd MMM yyyy',
          useMaskBehavior: true,
          width: '100%',
          openOnFieldClick: true,
          placeholder: 'Tanggal Lahir',
        },
      },
      // {
      //   dataField: 'alamat',
      //   label: {
      //     text: 'Alamat',
      //   },
      //   editorOptions: {
      //     elementAttr: { class: 'bd-input-popup-dapen-default' },
      //     placeholder: 'Alamat',
      //   },
      // },
      // {
      //   dataField: 'noRek',
      //   label: {
      //     text: 'Nomor Rekening',
      //   },
      //   editorOptions: {
      //     elementAttr: { class: 'bd-input-popup-dapen-default' },
      //     placeholder: 'Nomor Rekening',
      //   },
      // },
    ]

    this.columns = [
      {
        dataField: 'no',
        caption: 'No.',
        cellRender: (e) => {
          return e.rowIndex + 1
        },
        width: '40px',
      },
      {
        dataField: 'namaLengkap',
        caption: 'Nama Lengkap',
      },
      {
        dataField: 'nik',
        caption: 'NIK',
      },
      {
        dataField: 'nomorKtp',
        caption: 'Nomor KTP',
      },
      {
        dataField: 'nomorHp',
        caption: 'Nomor HP',
      },
      {
        dataField: 'tanggalLahir',
        caption: 'Tanggal Lahir',
        dataType: 'date',
        format: 'dd MMM yyyy',
      },
      // {
      //   dataField: 'alamat',
      //   caption: 'Alamat',
      // },
      // {
      //   dataField: 'noRekening',
      //   caption: 'Nomor Rekening',
      // },
      {
        dataField: 'product',
        caption: 'Produk',
      },
      {
        dataField: 'action',
        caption: 'Aksi',
        cellRender: (e) => {
          return (
            <button
              className="btn btn-sm btn-outline-dark"
              onClick={async () => this.getAllData(e.row.data)}
            >
              <i className="fa fa-eye"></i>
            </button>
          )
        },
        width: 'auto',
      },
    ]
  }

  componentWillMount() {
    let store = this.props.store
    store.dispatch(addURL(this.props.location.pathname))
  }

  forceRefresh = () => {
    this.datagridPesertaRef.current.forceRefresh(true)
  }

  clearData = () => {
    this.dataResult = []
    this.forceRefresh()

    this.setState({
      formData: {},
    })
  }

  advanceSearch = async () => {
    let { cardNo, fullName, nik, ktp, noHp, tanggalLahir, alamat, noRek } =
      this.state.formData

    if (
      !cardNo &&
      !fullName &&
      !nik &&
      !ktp &&
      !noHp &&
      !tanggalLahir &&
      !alamat &&
      !noRek
    ) {
      alert('Harus terdapat minimal 1 kolom yang diisi', 'Tidak Sesuai')
    }

    this.props.store.dispatch(showLoading(true))
    try {
      let getDatagrid = await httpRequest(
        process.env.REACT_APP_BACKEND_CORE,
        this.props.store,
        `db-client-search`,
        'POST',
        {
          values: {
            cardNo: cardNo,
            fullName: fullName,
            nik: nik,
            ktp: ktp,
            noHp: noHp,
            tanggalLahir: tanggalLahir ? formatDate(tanggalLahir) : null,
            alamat: alamat,
            noRek: noRek,
            participantId: this.props.store.getState().sessionUser
              ? this.props.store.getState().sessionUser.participantId
              : 0,
          },
        }
      )

      if (getDatagrid.length > 0) {
        this.dataResult = getDatagrid
        this.forceRefresh()
        this.props.store.dispatch(showLoading(false))
      } else {
        this.dataResult = []
        this.forceRefresh()
        this.props.store.dispatch(showLoading(false))
      }
    } catch (e) {
      console.error(e)
      this.props.store.dispatch(showLoading(false))
    }
  }

  loadData = () => {
    return this.dataResult
  }

  getAllData = async (data) => {
    if (data) {
      this.props.store.dispatch(showLoading(true))
      try {
        let cardValue = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `card/kp/${data.kpId}`,
          'GET'
        )
        let getProfile = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `client-profile/${data.kpId}`,
          'GET'
        )
        let getKepegawaian = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `client-kepegawaian/${data.kpId}`,
          'GET'
        )
        let getIuran = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `client-iuran/${data.kpId}`,
          'GET'
        )
        let getKeluarga = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `client-db-keluarga/${data.kpId}`,
          'GET'
        )
        let getSaldo = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `ppip-transactions/db-client-saldo/${data.kpId}`,
          'GET'
        )
        let simulasiMp = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `db-client-simulasi-mp/${data.kpId}`,
          'GET'
        )
        let simulasiBerkala = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `db-client-simulasi-berkala/${data.kpId}`,
          'GET'
        )
        let riwayatTransaksi = await httpRequest(
          process.env.REACT_APP_BACKEND_CORE,
          this.props.store,
          `db-client-riwayat-transaksi/${data.kpId}`,
          'GET'
        )

        this.profilePesertaRef.current.retrieveData(
          cardValue,
          getProfile,
          getKepegawaian
        )
        this.detailDataRef.current.retrieveData({
          iuran: getIuran,
          keluarga: getKeluarga,
          saldo: getSaldo,
          riwayatTransaksi: riwayatTransaksi,
          simulasiMp: simulasiMp,
          simulasiBerkala: simulasiBerkala,
        })

        this.props.store.dispatch(showLoading(false))
      } catch (e) {
        console.error(e)
        this.props.store.dispatch(showLoading(false))
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="container-fluid overflow-auto h-100">
          <div>
            <Form
              colCount={3}
              id={'advanceSearchForm'}
              labelLocation={'left'}
              formData={this.state.formData}
              items={this.formItems}
              ref={this.formRef}
            />
          </div>

          <div className="d-flex flex-row justify-content-end">
            <Button
              elementAttr={{
                class: 'bg-button-popup-save-dapen-default mr-2',
              }}
              text={'Proses'}
              type={'success'}
              stylingMode={'contained'}
              onClick={async (e) => {
                await this.advanceSearch()
              }}
              visible={true}
            />
            <Button
              elementAttr={{
                class: 'bg-button-popup-close-dapen-default',
              }}
              text={'Hapus'}
              type={'success'}
              stylingMode={'contained'}
              onClick={() => {
                this.clearData()
              }}
              visible={true}
            />
          </div>

          <div className="mt-3">
            <DevExpressDataGrid
              keyField="kpId"
              ref={this.datagridPesertaRef}
              loadAPI={`-`}
              insertAPI="-"
              updateAPI="-"
              deleteAPI="-"
              backendserver={process.env.REACT_APP_BACKEND_CORE}
              useArraySource={true}
              ArraySourceData={this.loadData}
              allowAdding={false}
              allowDeleting={false}
              allowUpdating={false}
              height={'35vh'}
              exportExcel={false}
              exportFileName={'Pengajuan Peserta Pensiun Ditunda'}
              allowExportSelectedData={false}
              showBorders={true}
              paging={false}
              defaultPageSize={5}
              popupTitle={'Pengajuan Peserta Pensiun Ditunda'}
              popupWidth={700}
              popupHeight={500}
              popupFormLabelLocation="left"
              popupFormMinColWidth={300}
              popupFormColCount={3}
              ColumnChooser={false}
              ColumnFixing={false}
              FilterRow={false}
              ColumnConfiguration={this.columns}
              store={this.props.store}
            />
          </div>

          <div className="row">
            <div className="col-md-3 mt-3">
              <ProfilePeserta
                store={this.props.store}
                ref={this.profilePesertaRef}
              />
            </div>
            <div className="col-md-9 mt-3">
              <DetailData store={this.props.store} ref={this.detailDataRef} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default DashboardClient
